<template>
  <b-form @submit.prevent="onSubmit">
    <b-row>
      <b-col cols="12" class="pb-4 px-2">
        <b-card no-body class="card px-2 pb-4 container-card">
          <b-card-header>
            <span class="information-header">Criteria</span>
          </b-card-header>
          <div class="px-2">
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-end mt-2 mb-1">
                  <add-button
                    :btn-label="'Add'"
                    @click.native="openCriteriaModal"
                  />
                </div>
              </div>
            </div>
          </div>
          <b-row class="mb-3">
            <b-col>
              <overlay-loading :loading="loading.tableData">
                <template #content>
                  <b-table
                    :fields="fields.criteriaTable"
                    :items="formData.critiriaTable"
                    responsive
                    bordered
                    borderless
                    sticky-header
                    show-empty
                    no-local-sorting
                    class="default-static-table"
                  >
                    <template #cell(list)="data">
                      <div
                        v-for="(item, index) in data.item.criteria"
                        :key="index + '-list'"
                        class="d-inline-block mr-1 mb-1"
                      >
                        <b-button
                          size="sm"
                          :variant="item.criteria ? 'info' : 'light'"
                          pill
                        >
                          {{ item.tagname }}
                        </b-button>
                      </div>
                      <div v-if="data.item.criteria == ''">
                        <div class="d-inline-block mr-1 mb-1">
                          <b-button size="sm" :variant="'light'" pill>
                            All
                          </b-button>
                          <div class="d-inline-block mr-1 mb-1">
                            <b-button size="sm" :variant="'info'" pill>
                              All
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </template>

                    <template #cell(updatedtime)="data">
                      <div>
                        {{
                          data.item.updatedtime
                            ? resolveDate(data.item.updatedtime) +
                              " " +
                              resolveTime(data.item.updatedtime)
                            : "-"
                        }}
                      </div>
                    </template>

                    <template #cell(actions)="data">
                      <div class="d-flex justify-content-center">
                        <b-button
                          variant="secondary"
                          class="banner-action mr-2"
                          @click="
                            openCriteriaModal(data.item.criteria_groupid, true)
                          "
                        >
                          <edit-icon
                            class="banner-group-action-svg iconEdit-btn"
                          />
                        </b-button>
                        <b-button
                          variant="secondary"
                          class="banner-action mr-2"
                          @click="openDeleteWarningModal(data.item)"
                        >
                          <delete-icon class="banner-group-action-svg" />
                        </b-button>
                      </div>
                    </template>
                    <template #table-busy>
                      <overlay-loading :loading="true" />
                    </template>
                    <template #empty>
                      <card-no-item :text-no-img="'Item Not Found'" />
                    </template>
                  </b-table>
                </template>
              </overlay-loading>
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-12 mb-3">
              <pagination-with-reorder
                entity-editable
                :pagination="pagination"
                @entityChange="onFilterEntity"
                @pageChange="onPageChange"
              />
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <manage-criteria-modal
      v-if="modalType.manageCriteria"
      :is-edit="isEditCriteria"
      :formDataObj="criteriaItem"
      @onCloseModal="closeCriteriaModal"
      @onSubmit="onSaveCriteria"
    />
    <b-col cols="12" class="d-flex justify-content-center mt-2">
      <cancel-button
        class="mr-1"
        :btn-label="'Back'"
        @click.native="$emit('onPreviousStep')"
        stageBack
      />
      <save-button class="ml-1" :type="'submit'" :loading="loading.submit" />
    </b-col>
  </b-form>
</template>

<script>
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import useBannerCriteria from "../hooks/useBannerCriteria";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import ManageCriteriaModal from "./ManageCriteriaModal.vue";
export default {
  components: {
    CardNoItem,
    PaginationWithReorder,
    ManageCriteriaModal,
    EditIcon,
    DeleteIcon,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    bannerId: { type: Number, default: 0 },
  },
  setup(props) {
    const {
      loading,
      fields,
      criteriaListTable,
      pagination,
      paginationInfo,
      onPageChange,
      onFilterEntity,
      isEditCriteria,
      modalType,
      openCriteriaModal,
      closeCriteriaModal,
      openDeleteWarningModal,
      formData,
      criteriaItem,
      onSaveCriteria,
      onSubmit
    } = useBannerCriteria(props);

    return {
      loading,
      fields,
      criteriaListTable,
      pagination,
      paginationInfo,
      onPageChange,
      onFilterEntity,
      isEditCriteria,
      modalType,
      openCriteriaModal,
      closeCriteriaModal,
      openDeleteWarningModal,
      formData,
      criteriaItem,
      onSaveCriteria,
      onSubmit
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/banner/banner-table.css";
</style>